<template>
    <div>
        <!-- Tabs Navigation -->
        <ul class="nav nav-tabs" id="tabs" role="tablist">
            <li class="nav-item" v-for="tab in tabs" :key="tab.name" role="presentation">
                <button class="nav-link" :class="{ active: activeTab === tab.name }" @click="setActiveTab(tab.name)"
                    type="button" role="tab">
                    <img v-if="tab.label == 'Ορφανά από Μονάδα εφαρμογής'" src="../assets/images/error16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    <img v-if="tab.label == 'Ορφανά από Ίδρυμα ιστών'" src="../assets/images/error16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    <img v-if="tab.label == 'Εφαρμοσμένα ληγμένα'" src="../assets/images/warning16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">
                    {{ tab.label }}

                </button>
            </li>
        </ul>
        <!-- Tabs Content -->
        <div class="tab-content mt-3">
            <div v-if="activeTab === 'orphan_hospital'">
                <div class="d-flex">
                    <div>
                        <div class="d-flex">
                   
                            <input type="text" class="form-control ms-2" style="max-width:30%" v-model="searchValue" placeholder="Αναζήτηση στη λίστα"/>
                            <button class="btn ms-2" @click="handleRefresh('orphan_hospital')"><img src="../assets/images/reset16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Ανανέωση</button>
                            <button class="btn ms-2" @click="handleExport('orphan_hospital')"><img src="../assets/images/excel16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">MS-Excel</button>

                        </div>

                        <table class="table table-bordered table-hover">
                            <tr style="border-bottom: 2px solid gray;"><td></td><td>Σύνολο: {{ totalCount }}</td><td></td><td></td><td></td><td></td><td></td></tr>

                            <thead class="table-light">
                                <tr>
                                    <th @click="sortTable('id')" style="width:6%">
                                        A/A
                                        <span v-if="sortKey === 'id'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('implant_name')">
                                        Μοσχευμα
                                        <span v-if="sortKey === 'implant_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('category')">
                                        Κατηγορια
                                        <span v-if="sortKey === 'category'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('provider_name')">
                                        Προμηθευτης 
                                        <span v-if="sortKey === 'provider_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('sec')" style="width:12%">
                                        Κωδικος SEC
                                        <span v-if="sortKey === 'sec'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_insdate')">
                                        ΗΜ/ΝΙΑ ΔΗΛΩΣΗΣ ΕΙΣΑΓΩΓΗΣ
                                        <span v-if="sortKey === 'inst_insdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('location')" style="width:8%">
                                        Προελευση
                                        <span v-if="sortKey === 'location'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_recvdate')">
                                        Ημ/νια εισαγωγης
                                        <span v-if="sortKey === 'inst_recvdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('exp_date')">
                                        Ημ/νια ληξης
                                        <span v-if="sortKey === 'exp_date'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('proto_num')">
                                        Αρ. Πρωτ/λου
                                        <span v-if="sortKey === 'proto_num'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('proto_date')">
                                        Ημ/νια Πρωτ/λου
                                        <span v-if="sortKey === 'proto_date'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('institution_name')">
                                        Ιδρυμα Ιστων 
                                        <span v-if="sortKey === 'institution_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('hospital_name')" style="width:16%">
                                        Μοναδα εφαρμογης
                                        <span v-if="sortKey === 'hospital_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="implant in orphanHospital" :key="implant.id">
                                    <td><img
                                        src="../assets/images/implant16.png"
                                        alt="Applied Icon"
                                        class="menu-img"
                                        style="width:1em; margin-right:3px; margin-bottom:3px"
                                        />{{ implant.id }}</td>
                                    <td>{{ implant.implant_name }}</td>
                                    <td>{{ implant.category }}</td>
                                    <td>{{ implant.provider_name }}</td>
                                    <td :title="implant.sec">{{ limitSec(implant.sec) }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_insdate) }}</td>
                                    <td>{{ implant.provider_location }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_recvdate) }}</td>
                                    <td>{{ formatLicenseExp(implant.exp_date) }}</td>
                                    <td>{{ implant.proto_num }}</td>
                                    <td>{{ formatLicenseExp(implant.proto_date) }}</td>
                                    <td>{{ implant.institution_name }}</td>
                                    <td>{{ implant.hospital_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation">
                            <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                                <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                    :key="index" :class="{ active: paginationLink.active }">
                                    <router-link
                                        :to="{ path: 'alerts', query: { page: getPageFromUrl(paginationLink.url) } }"
                                        v-if="paginationLink.url">
                                        <span class="page-link" v-html="paginationLink.label"></span>
                                    </router-link>
                                    <span class="page-link" v-else v-html="paginationLink.label"></span>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <div v-if="activeTab === 'orphan_institution'">
                <div class="d-flex">
                    <div>
                        <div class="d-flex">
                            <input type="text" class="form-control ms-2" style="max-width:30%" v-model="searchValue" placeholder="Αναζήτηση στη λίστα"/>
                            <button class="btn ms-2" @click="handleRefresh('orphan_institution')"><img src="../assets/images/reset16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Ανανέωση</button>
                            <button class="btn ms-2" @click="handleExport('orphan_institution')"><img src="../assets/images/excel16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">MS-Excel</button>
                        </div>
                        <table class="table table-bordered table-hover">
                            <tr style="border-bottom: 2px solid gray;"><td></td><td>Σύνολο: {{ totalCount }}</td><td></td><td></td><td></td><td></td><td></td></tr>
                            <thead class="table-light">
                                <tr>
                                    <th @click="sortTable('id')" style="width:6%">
                                        A/A
                                        <span v-if="sortKey === 'id'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('implant_name')">
                                        Μοσχευμα
                                        <span v-if="sortKey === 'implant_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('category')">
                                        Κατηγορια
                                        <span v-if="sortKey === 'category'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('provider_name')">
                                        Προμηθευτης 
                                        <span v-if="sortKey === 'provider_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('sec')">
                                        Κωδικος SEC
                                        <span v-if="sortKey === 'sec'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_insdate')">
                                        ΗΜ/ΝΙΑ ΔΗΛΩΣΗΣ ΕΙΣΑΓΩΓΗΣ 
                                        <span v-if="sortKey === 'inst_insdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('provider_location')">
                                        Προελευση
                                        <span v-if="sortKey === 'provider_location'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_recvdate')">
                                        Ημ/νια εισαγωγης
                                        <span v-if="sortKey === 'inst_recvdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('exp_date')">
                                        Ημ/νια ληξης
                                        <span v-if="sortKey === 'exp_date'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('proto_num')">
                                        Αρ. Πρωτ/λου
                                        <span v-if="sortKey === 'proto_num'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('proto_date')">
                                        Ημ/νια Πρωτ/λου
                                        <span v-if="sortKey === 'proto_date'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>

                                    <th @click="sortTable('institution_name')">
                                        Ιδρυμα Ιστων 
                                        <span v-if="sortKey === 'institution_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>

                                     <th @click="sortTable('hospital_name')" style="width:16%">
                                        Μοναδα εφαρμογης
                                        <span v-if="sortKey === 'hospital_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="implant in orphanInstitution" :key="implant.id">
                                    <td><img
                                        src="../assets/images/implant16.png"
                                        alt="Applied Icon"
                                        class="menu-img"
                                        style="width:1em; margin-right:3px; margin-bottom:3px"
                                        />{{ implant.id }}</td>
                                    <td>{{ implant.implant_name }}</td>
                                    <td>{{ implant.category }}</td>
                                    <td>{{ implant.provider_name }}</td>
                                    <td :title="implant.sec">{{ limitSec(implant.sec) }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_insdate) }}</td>
                                    <td>{{ implant.provider_location }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_recvdate) }}</td>
                                    <td>{{ formatLicenseExp(implant.exp_date) }}</td>
                                    <td>{{ implant.proto_num }}</td>
                                    <td>{{ formatLicenseExp(implant.proto_date) }}</td>
                                    <td>{{ implant.institution_name }}</td>
                                    <td>{{ implant.hospital_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation">
                            <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                                <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                    :key="index" :class="{ active: paginationLink.active }">
                                    <router-link
                                        :to="{ path: 'alerts', query: { page: getPageFromUrl(paginationLink.url) } }"
                                        v-if="paginationLink.url">
                                        <span class="page-link" v-html="paginationLink.label"></span>
                                    </router-link>
                                    <span class="page-link" v-else v-html="paginationLink.label"></span>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <!-- Implant Details -->
                    <div class="implant_details" v-if="implantShown">
                        <div class="d-flex">
                            <button class="btn btn-secondary" @click="download">Κατέβασμα αρχείου</button>
                            <button class="btn btn-secondary" @click="closeDetails">Κλείσιμο</button>
                        </div>
                        <h6 class="fw-bolder">Στοιχεία Μη Εφαρμοσμένου Μοσχεύματος</h6>
                        <p><strong>Όνομα:</strong> {{ selectedImplant.implant_name }}</p>
                        <p><strong>Κατηγορία:</strong> {{ selectedImplant.category }}</p>
                        <p><strong>Ημ/νία δήλωσης:</strong> {{ selectedImplant.inst_insdate }}</p>
                        <p><strong>Ημ/νία παραλαβής:</strong> {{ selectedImplant.inst_recvdate }}</p>
                        <p><strong>Ημ/νία λήξης:</strong> {{ selectedImplant.exp_date }}</p>
                        <p><strong>Κωδικός SEC:</strong> {{ selectedImplant.sec }}</p>
                        <p><strong>Ημ/νία εφαρμογής:</strong> {{ selectedImplant.apply_date }}</p>
                        <p><strong>Κατάσταση:</strong> {{ selectedImplant.apply_status }}</p>
                        <p><strong>Προμηθευτής:</strong> {{ selectedImplant.provider_name }}</p>
                        <p><strong>Μονάδα εφαρμογής:</strong> {{ selectedImplant.hospital_name }}</p>
                    </div>
                </div>
            </div>
            <div v-if="activeTab === 'applied_expired'">
                <div class="d-flex">
                    <div>
                        <div class="d-flex">
                            <label for="institute_relations ms-2 mt-3" style="margin-right:20px; margin-top:10px" class="form-label">
                    Αναζήτηση με:
                </label>
                            <select name="institute_relations ms-2" style="max-width:30%" class="form-control" v-model="searchField" placeholder="Επιλέξτε κριτήριο" @change="handleRefresh">
                                <option value="" selected>Επιλέξτε κριτήριο</option>
                                <option value="implant_name">Μoσχευμα</option>
                                <option value="category">Κατηγορία</option>
                                <option value="provider_name">Προμηθευτής</option>
                                <option value="hospital_name">Μονάδα εφαρμογής</option>
                                <option value="sec">Κωδικός SEC</option>
                            </select>
                            <input type="text" class="form-control ms-2" style="max-width:30%" v-model="searchValue" placeholder="Αναζήτηση"/>
                            <button class="btn ms-2" @click="handleRefresh('applied_expired')"><img src="../assets/images/reset16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Ανανέωση</button>
                            <button class="btn ms-2" @click="handleExport('applied_expired')"><img src="../assets/images/excel16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">MS-Excel</button>
                        </div>
                        <table class="table table-bordered table-hover">
                            <tr style="border-bottom: 2px solid gray;"><td></td><td>Σύνολο: {{ totalCount }}</td><td></td><td></td><td></td><td></td><td></td></tr>
                            <thead class="table-light">
                                <tr>
                                    <th @click="sortTable('id')" style="width:6%">
                                        A/A
                                        <span v-if="sortKey === 'id'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('implant_name')">
                                        Μoσχευμα
                                        <span v-if="sortKey === 'implant_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('category')">
                                        Κατηγορια
                                        <span v-if="sortKey === 'category'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('provider_name')">
                                        Προμηθευτης
                                        <span v-if="sortKey === 'provider_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('sec')">
                                        Κωδικος SEC
                                        <span v-if="sortKey === 'sec'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_insdate')">
                                        ΗΜ/ΝΙΑ ΔΗΛΩΣΗΣ ΕΙΣΑΓΩΓΗΣ
                                        <span v-if="sortKey === 'inst_insdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('inst_recvdate')">
                                        Ημ/νια εισαγωγης
                                        <span v-if="sortKey === 'inst_recvdate'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('exp_date')">
                                        Ημ/νια ληξης
                                        <span v-if="sortKey === 'exp_date'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <!-- <th @click="sortTable('status')">
                                        Κατασταση
                                        <span v-if="sortKey === 'status'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th> -->
                                    <th @click="sortTable('hospital_name')" style="width:16%">
                                        Μοναδα εφαρμογης
                                        <span v-if="sortKey === 'hospital_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                    <th @click="sortTable('apply_date')" style="width:16%">
                                        Ημ/νία Εφαρμογής
                                        <span v-if="sortKey === 'apply_date'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                     <th @click="sortTable('institution_name')" style="width:16%">
                                        Iδρυμα Ιστων
                                        <span v-if="sortKey === 'institution_name'">
                                            <i :class="sortOrder === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down'"></i>
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="implant in appliedExpired" :key="implant.id">
                                    <td><img
                                        src="../assets/images/blt_orange.png"
                                        alt="Applied Icon"
                                        class="menu-img"
                                        style="width:1em; margin-right:3px; margin-bottom:3px"
                                        />{{ implant.id }}</td>
                                    <td>{{ implant.implant_name }}</td>
                                    <td>{{ implant.category }}</td>
                                    <td>{{ implant.provider_name }}</td>
                                    <td :title="implant.sec">{{ limitSec(implant.sec) }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_insdate) }}</td>
                                    <td>{{ formatLicenseExp(implant.inst_recvdate) }}</td>
                                    <td>{{ formatLicenseExp(implant.exp_date) }}</td>
                                    <!-- <td>{{ implant.status }}</td> -->
                                    <td>{{ implant.hospital_name }}</td>
                                    <td>{{ formatLicenseExp(implant.apply_date) }}</td>
                                    <td>{{ implant.institution_name }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation">
                            <ul class="pagination mt-4" v-if="paginationLinks && paginationLinks.length > 0">
                                <li class="page-item" v-for="(paginationLink, index) in paginationLinks"
                                    :key="index" :class="{ active: paginationLink.active }">
                                    <router-link
                                        :to="{ path: 'alerts', query: { page: getPageFromUrl(paginationLink.url) } }"
                                        v-if="paginationLink.url">
                                        <span class="page-link" v-html="paginationLink.label"></span>
                                    </router-link>
                                    <span class="page-link" v-else v-html="paginationLink.label"></span>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <!-- Implant Details -->
                    <div class="implant_details" v-if="implantShown">
                        <div class="d-flex">
                            <button class="btn btn-secondary" @click="download">Κατέβασμα αρχείου</button>
                            <button class="btn btn-secondary" @click="closeDetails">Κλείσιμο</button>
                        </div>
                        <h6 class="fw-bolder">Στοιχεία Μη Εφαρμοσμένου Μοσχεύματος</h6>
                        <p><strong>Όνομα:</strong> {{ selectedImplant.implant_name }}</p>
                        <p><strong>Κατηγορία:</strong> {{ selectedImplant.category }}</p>
                        <p><strong>Ημ/νία δήλωσης:</strong> {{ selectedImplant.inst_insdate }}</p>
                        <p><strong>Ημ/νία παραλαβής:</strong> {{ selectedImplant.inst_recvdate }}</p>
                        <p><strong>Ημ/νία λήξης:</strong> {{ selectedImplant.exp_date }}</p>
                        <p><strong>Κωδικός SEC:</strong> {{ selectedImplant.sec }}</p>
                        <p><strong>Ημ/νία εφαρμογής:</strong> {{ selectedImplant.apply_date }}</p>
                        <!-- <p><strong>Κατάσταση:</strong> {{ selectedImplant.apply_status }}</p> -->
                        <p><strong>Προμηθευτής:</strong> {{ selectedImplant.provider_name }}</p>
                        <p><strong>Μονάδα εφαρμογής:</strong> {{ selectedImplant.hospital_name }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { getInstitutions, postInstitute, deleteInstitutionById, deleteRelationsForInstitute, getInstalled, getNotUsed, getUsed, getExpired, downloadExportInstall, downloadExportNotUsed, downloadExportUsed, downloadExportExpired, downloadFile } from "../services/institutions";
import { deleteHospitalById, getHospitals, postHospital } from "@/services/hospitals";
import { getGrafts, getGraftCategories, postCategory, postImplant, actImplant, deleteRelationsForImplant } from "@/services/grafts";
import { useToast } from "vue-toastification";
import * as XLSX from 'xlsx';
import { actProvider, deleteRelationsForProvider, getCountries, getSuppliers, postProvider } from "@/services/suppliers";
import { downloadExportOrphanHospitals, downloadExportOrphanInstitutes, downloadExportUsedExpired, eomGetExpired } from "@/services/alerts";

export default {
    data() {
        return {
            totalCount: 0,
            activeTab: "orphan_hospital",
            tabs: [
                { name: "orphan_hospital", label: "Ορφανά από Μονάδα εφαρμογής" },
                { name: "orphan_institution", label: "Ορφανά από Ίδρυμα ιστών" },
                { name: "applied_expired", label: "Εφαρμοσμένα ληγμένα" },
            ],
            searchField: "",
            searchValue: "",
            institutions: [],
            orphanHospital: [],
            orphanInstitution: [],
            appliedExpired: [],
            expiredImplants: [],
            paginationLinks: [],
            page: 1,
            selectedInsituteId: "0",
            selectedImplant: null,
            sortKey: "id",
            sortOrder: "desc",
            selectedField: "",
            implantShown: false
        };
    },
    methods: {
        sortTable(column) {
            if (this.sortKey === column) {
                // Reverse order if the column is already sorted
                this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
            } else {
                this.sortKey = column;
                this.sortOrder = "asc";
            }
            this.handleRefresh(this.activeTab);
        },
        limitSec(sec) {
        if (sec && sec.length > 10) {
            return sec.substring(0, 10) + '...';
        }
        return sec;
    },
        getPageFromUrl(url) {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        },
        // Existing methods remain unchanged...
        setActiveTab(tabName) {
            this.activeTab = tabName;
            // Update the URL with page = 1
            this.$router.push({
                path: this.$route.path,
                query: { ...this.$route.query, page: 1 }
            });
            this.searchField = "";
            this.searchValue = "";
            // Trigger refresh for the new tab
            this.handleRefresh(tabName);
        },
        async handleRefresh(tabName) {
            if (tabName === 'orphan_hospital') {
                let params = {
                    instid: this.selectedInsituteId,
                    sortBy: this.sortKey,
                    sortOrder: this.sortOrder,
                    page: this.page,
                    pageTitle:'alerts'
                };
                if (this.searchValue != "") {
                    params.search = this.searchValue;
                }
                const notUsedImplants = (await getUsed(params)).data.data;

                this.orphanHospital = notUsedImplants.results.data;
                this.totalCount = notUsedImplants.count;
                this.paginationLinks = notUsedImplants.results.links;
            } else if (tabName === 'orphan_institution') {
                let params = {
                    instid: this.selectedInsituteId,
                    sortBy: this.sortKey,
                    sortOrder: this.sortOrder,
                    page: this.page,
                    pageTitle:'alerts'
                };
                if (this.searchValue != "") {
                    params.search = this.searchValue;
                }
                const usedImplants = (await getNotUsed(params)).data.data;

                this.orphanInstitution = usedImplants.results.data;
                this.totalCount = usedImplants.count;
                this.paginationLinks = usedImplants.results.links;
            } else if (tabName === 'applied_expired') {
                let params = {
                    instid: this.selectedInsituteId,
                    sortBy: this.sortKey,
                    sortOrder: this.sortOrder,
                    page: this.page
                };
                if (this.searchValue != "") {
                    params[this.searchField] = this.searchValue;
                }
                const expiredImplants = (await eomGetExpired(params)).data.data;
                this.appliedExpired = expiredImplants.results.data;
                this.totalCount = expiredImplants.count;
                this.paginationLinks = expiredImplants.results.links;
            }
        },
        handleExport(tabName) {
            if (tabName == 'orphan_hospital') {
                let params = {
                    instid: this.selectedInsituteId,
                    sortBy: this.sortKey,
                    sortOrder: this.sortOrder,
                    page: this.page
                };
                if (this.searchValue != "") {
                    params.search = this.searchValue;
                }
                downloadExportOrphanHospitals(params);
            } else if (tabName == 'orphan_institution') {
                let params = {
                    instid: this.selectedInsituteId,
                    sortBy: this.sortKey,
                    sortOrder: this.sortOrder,
                    page: this.page
                };
                if (this.searchValue != "") {
                    params.search = this.searchValue;
                }
                downloadExportOrphanInstitutes(params);
            } else if (tabName == 'applied_expired') {
                let params = {
                    instid: this.selectedInsituteId,
                    sortBy: this.sortKey,
                    sortOrder: this.sortOrder,
                    page: this.page
                };
                if (this.searchValue != "") {
                    params[this.searchField] = this.searchValue;
                }
                downloadExportUsedExpired(params);
            }
        },
        formatLicenseExp(date) {
            if (date == null) { return ''}
            return new Date(date).toLocaleDateString("el-GR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        }
    },
    async mounted() {
        this.setActiveTab('orphan_hospital');
    },
    watch: {
        $route: {
            immediate: true,
            handler(newRoute) {
                const page = newRoute.query.page || 1; // Default to page 1 if not in URL
                this.page = page;
                this.handleRefresh(this.activeTab);
            }
        },
        selectedInsituteId: {
            immediate: true,
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh(this.activeTab);
            }
        },
        searchField: {
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh(this.activeTab);
            }
        },
        searchValue: {
            handler() {
                this.page = 1; // Reset to page 1
                // Update the URL with page = 1
                this.$router.push({
                    path: this.$route.path,
                    query: { ...this.$route.query, page: 1 }
                });
                this.handleRefresh(this.activeTab);
            }
        }
    }
};
</script>

<style scoped>
.nav-tabs {
    border-bottom: 1px solid #ddd;
}

.nav-link {
    cursor: pointer;
}

.table {
    margin-top: 1rem;
}

.btn{
    background-color: #f6f6f6;
}

.btn:hover, .btn-md:hover{
    background-color: #ececec;
}
.btn-md{
    background-color: white;
    border:none;
}

.nav-link.active{
    border:none;
}

.modal-header{
   background-color: #6DB4E3;
}

.modal-title{
color:white;
}

.modal-content{
    border:none;
    margin-top:30%;
}
/* Add hover effect for rows */
.institution-row:hover .btn-md {
    background-color: #ececec;
}

.hospital-row:hover .btn-md {
    background-color: #ececec;
}

.table {
    width: 100%; /* Ensure table stays within bounds */
    table-layout: fixed; /* Prevent columns from expanding uncontrollably */
    word-wrap: break-word; /* Handle long text gracefully */
}

th, td {
    text-align: left;
    vertical-align: middle;
    padding: 8px;
}

.btn2{
   background-color: #6DB4E3;
   color:white;
   border:none;
   border-radius:5px;
   padding:10px;
   margin-right:8px;
}
</style>